import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContainerSizeDirective } from './container-size.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ContainerSizeDirective],
  exports: [ContainerSizeDirective]
})
export class ContainerSizeModule {}
